import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputLabel from '@mui/material/InputLabel';

import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../../elementos/iconos/IconosGenerales";
import { useParams } from "react-router-dom";
import { handleChangeErrors, handleSubmitErrorsDepartamentos, todosDatosCorrectos } from '../../validacion/ValidationFormDepartamento';
import { fetchEditarDepartamento, fetchDepartamentoData } from '../../../peticiones_API/PeticionesGestionPersonasDepartamentos';
import { DatosCorrectosDepartamento, ServerNoCreoDepartamento, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';

import ErrorForm from '../eventos/avisos/Alerta';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';import { ToastContainer, toast } from "react-toastify";

const FormEditarDepartamento = ({ departamentos, negocios }) => {

    const { Id } = useParams();
    const [departamentoData, setDepartamentoData] = useState({
        id: Id
    });
    const [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
            departamentoDuplicado: null
    
        });

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null
    });

    const [botonRenderClick, setBotonRenderClick] = useState(false);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };


    const handleChangeNegocios = (event) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
        
        const {
            target: { value },
        } = event;
        setDepartamentoData(prevData => ({
            ...prevData,
            Negocios: value.map(id => ({ Id: id }))
        }));
    };

    const handleChange = (event) => {

            setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
    
            const { name, value } = event.target;
    
            let newValue = value;
            
            setDepartamentoData(prevDepartamentoData => ({ ...prevDepartamentoData, [name]: newValue }));
            if (name in estadoCampoReque) {
                handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
            }
    
        };

    const handleSubmit = async (event) => { 
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        setEstadosActualizados(false);

        handleSubmitErrorsDepartamentos(departamentoData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
        /*console.log("campoReque", estadoCampoReque);
        console.log("camposRequeridos", camposRequeridos);*/
        let validacionTodosDatos = todosDatosCorrectos(departamentoData, estadoCampoReque);
        //console.log("todosCamposFalse", todosCamposFalse);
        

     };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const departamento = await fetchDepartamentoData(Id);
                setDepartamentoData(departamento);
                console.log("DepartamentoData", departamento);
            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (estadosActualizados) {
            console.log("formData", departamentoData);
            console.log("estadoCampoReque", estadoCampoReque);
            let validacionTodosDatos = todosDatosCorrectos(departamentoData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    setErrorEnviarForm(prevFormData => ({ ...prevFormData, departamentoDuplicado: false }));
                    console.log("Simulacion editar departamento");
                    try {
                        const response = await fetchEditarDepartamento(departamentoData);
                    } catch (error) {
                        console.log(error.response.data.error);
                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, departamentoDuplicado: true }));
                        }
                        setFormCompletado(false);
                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
                setEstadosActualizados(false);
            })();
        }
    }, [estadosActualizados, departamentoData, estadoCampoReque]);

    return (
        <>
            <Form >
                <CabeceraForm>
                    <Titulo
                        texto="EDITAR UN DEPARTAMENTO"
                    />
                </CabeceraForm>
                <Container>
                    <ToastContainer/>
                    <Col>
                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                <Form.Control type="name" name="nombre" className="py-3" value={departamentoData.nombre || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                            </Form.Group>
                            <Form.Group className="mb-12">
                                <TituloCategoria>Negocios</TituloCategoria>
                                {negocios.length > 0 && (
                                <Select
                                    multiple
                                    style={{ width: '100%', maxWidth: '500px', minHeight: '40px' }}
                                    value={departamentoData.Negocios ? departamentoData.Negocios.map(negocio => negocio.Id) : []}
                                    onChange={handleChangeNegocios}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((id) => {
                                                const negocio = negocios.find(e => e.Id === id);
                                                return <Chip key={id} label={negocio ? negocio.nombre : ''} />;
                                            })}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {negocios.map((negocio) => (
                                        <MenuItem key={negocio.Id} value={negocio.Id}>
                                            {negocio.nombre}
                                        </MenuItem>
                                    ))}
                                </Select>
                                )}
                                <ErrorForm mensaje={camposRequeridos.negocios} estadoAlerta={estadoCampoReque.negocios} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Tipo de Departamento</TituloCategoria>
                                <div style={{ transform: 'scale(1.4)', marginLeft: '70px', marginTop: '15px' }}>
                                    <Form.Check
                                        type="checkbox"
                                        id="tipo-organigrama"
                                        label="Organigrama"
                                        checked={departamentoData.tipo === 'organigrama'}
                                        onChange={e => {
                                            setFormCompletado(null);
                                            setErrorEnviarForm({ departamentoDuplicado: null, refDuplicado: null });
                                            setDepartamentoData(prev => ({
                                                ...prev,
                                                tipo: e.target.checked ? 'organigrama' : 'interno'
                                            }));
                                        }}
                                    />
                                </div>
                            </Form.Group>
                        </Row>
                        <Row className="mt-4">
                            <ContenedorBotones>

                                    <Boton
                                        bonificados="true"
                                        grande="true"
                                        as="button"
                                        primario="true"
                                        type="submit"
                                        onClick={handleSubmit}
                                        form="true"
                                        name="guardar_cambios_statico"
                                    >
                                        Guardar
                                    </Boton>

                                    <Boton
                                        bonificados="true"
                                        grande="true"
                                        as="button"
                                        primario="true"
                                        type="submit"
                                        onClick={handleSubmit}
                                        form="true"
                                    >
                                        Guardar y Salir
                                    </Boton>
                                    <Boton
                                        grande="true"
                                        to="/gestionpersonas/departamentos"
                                    >
                                        Cancelar
                                    </Boton>
                                </ContenedorBotones>
                        </Row>
                    </Col>
                </Container>
            </Form>

            {botonRenderClick ? 
               <DatosCorrectosDepartamento envioActivado={formCompletado} />         
                :             
               <DatosCorrectosDepartamento envioActivado={formCompletado} redirect={false} />
            }

            
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.departamentoDuplicado} />
            <ServerNoCreoDepartamento envioActivado={errorEnviarForm.departamentoDuplicado} editar={true} />
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 2% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 30%;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`

export default FormEditarDepartamento;